import pathwaysBackground from '../images/pathways-background.svg'

const layout = {
  // for most feature pages
  standardPage: {
    maxWidth: '1136px',
    mt: 5,
    px: 4,
    pb: 5,
  },
  successPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mt: 5,
    px: 4,
    pb: 5,
    backgroundImage: ['none', 'none', `url(${pathwaysBackground})`],
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    height: 'calc(100vh - 236px)',
    width: '100vw',
  },
  // form pages with narrow form elements
  formPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mt: 5,
    px: 4,
    pb: 5,
    backgroundImage: ['none', 'none', `url(${pathwaysBackground})`],
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
  },
}

export default layout
